// [claude-code 2026-03-14] Compact nametag with ER emotional pulse (green=stable, red=tilt)
// [claude-code 2026-05-19] SOL-71: fixed "neutral" default (false-positive tilt pulse), palette to Solvys gold, added lockout state.
import { useERSafe } from "../contexts/ERContext";

interface TraderNametagProps {
  name: string;
  disablePulse?: boolean;
  variant?: "standalone" | "embedded";
}

export function TraderNametag({
  name,
  disablePulse,
  variant = "standalone",
}: TraderNametagProps) {
  if (!name) return null;

  const er = useERSafe();
  const resonance = er?.resonanceState ?? "poised"; // "poised" is the correct default (not "neutral")
  const isLockedOut = er?.isLockedOut ?? false;
  const showPulse = !disablePulse && resonance !== "poised";

  const pulseClass = isLockedOut
    ? "nametag-pulse-lockout"
    : showPulse
      ? resonance === "steadfast"
        ? "nametag-pulse-stable"
        : "nametag-pulse-tilt"
      : "";

  const chromeClass =
    variant === "embedded"
      ? "h-full px-2"
      : "bg-[var(--fintheon-bg)] border border-[var(--fintheon-accent)]/20 rounded-md px-2 h-7";

  return (
    <div
      className={`relative flex items-center overflow-hidden ${chromeClass} ${pulseClass}`}
      style={{ boxShadow: "inset 0 1px 0 rgba(199,159,74,0.25)" }}
    >
      <span className="relative z-10 text-[10px] font-semibold tracking-[0.14em] text-[var(--fintheon-accent)] uppercase select-none">
        {name}
      </span>
      <div
        className="absolute inset-0 z-0 nametag-shimmer"
        style={{
          background: "rgba(199,159,74,0.06)",
        }}
      />
    </div>
  );
}
